var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import axios from 'axios';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/MappingProjectEnums';
let MappingProject = class MappingProject extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.mappingProjectList = [];
        this.mappingProjectPaging = [];
        this.loadPage = false;
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.searchBy = '';
        this.status = '';
        this.statusMessage = '';
        this.filterstatus = 'No';
        this.useFilter = true;
        this.selectedProjectDescription = [];
        this.selectedProjectCode = [];
        this.selectedDirectorateCode = [];
        this.selectedDirectorateName = [];
        this.selectedFunctionCode = [];
        this.selectedFunctionName = [];
        this.selectedDivisionCode = [];
        this.selectedDivisionName = [];
        this.selectedDepartmentCode = [];
        this.selectedDepartmentName = [];
        this.mappingProjectListProjectCode = [];
        this.mappingProjectListProjectDesc = [];
        this.mappingProjectListDirectorateCode = [];
        this.mappingProjectListDirectorateName = [];
        this.mappingProjectListFunctionCode = [];
        this.mappingProjectListFunctionName = [];
        this.mappingProjectListDivisionCode = [];
        this.mappingProjectListDivisionName = [];
        this.mappingProjectListDepartmentCode = [];
        this.mappingProjectListDepartmentName = [];
        this.resetMappingProject = true;
        this.mappingProjectListDataUpdate = [];
        this.mappingProjectListDataUpdateMappingProject = [];
        this.mappingProjectListDataUpdateHierarchy = [];
        this.mappingProjectListDataUpdateWbs = [];
        this.mappingProjectListDataUpdateIndexHierarchy = [];
        this.mappingProjectListDataUpdateIndexWbs = [];
    }
    get getMappingProjectWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getUseFilterMappingProject() {
        return this.useFilter;
    }
    get getMappingProjectReset() {
        return this.resetMappingProject;
    }
    get getSelectedMappingProjectDesc() {
        return this.selectedProjectDescription;
    }
    get getSelectedMappingProjectCode() {
        return this.selectedProjectCode;
    }
    get getSelectedMappingProjectDirectorateCode() {
        return this.selectedDirectorateCode;
    }
    get getSelectedMappingProjectDirectorateName() {
        return this.selectedDirectorateName;
    }
    get getSelectedMappingProjectFunctionCode() {
        return this.selectedFunctionCode;
    }
    get getSelectedMappingProjectFunctionName() {
        return this.selectedFunctionName;
    }
    get getSelectedMappingProjectDivisionCode() {
        return this.selectedDivisionCode;
    }
    get getSelectedMappingProjectDivisionName() {
        return this.selectedDivisionName;
    }
    get getSelectedMappingProjectDepartmentCode() {
        return this.selectedDepartmentCode;
    }
    get getSelectedMappingProjectDepartmentnName() {
        return this.selectedDepartmentName;
    }
    get getMappingProjectLoading() {
        return this.loading;
    }
    get getMappingProjectLists() {
        return this.mappingProjectList;
    }
    get getMappingProjectListProjectCode() {
        return this.mappingProjectListProjectCode;
    }
    get getMappingProjectListProjectDesc() {
        return this.mappingProjectListProjectDesc;
    }
    get getMappingProjectListDirectorateCode() {
        return this.mappingProjectListDirectorateCode;
    }
    get getMappingProjectListDirectorateName() {
        return this.mappingProjectListDirectorateName;
    }
    get getMappingProjectListFunctionCode() {
        return this.mappingProjectListFunctionCode;
    }
    get getMappingProjectListFunctionName() {
        return this.mappingProjectListFunctionName;
    }
    get getMappingProjectListDivisionCode() {
        return this.mappingProjectListDivisionCode;
    }
    get getMappingProjectListDivisionName() {
        return this.mappingProjectListDivisionName;
    }
    get getMappingProjectListDepartmentCode() {
        return this.mappingProjectListDepartmentCode;
    }
    get getMappingProjectListDepartmentName() {
        return this.mappingProjectListDepartmentName;
    }
    get getMappingProjectPaging() {
        return this.mappingProjectPaging;
    }
    get getMappingProjectSize() {
        return this.size;
    }
    get getMappingProjectDesc() {
        return this.desc;
    }
    get getMappingProjectSearchBy() {
        return this.searchBy;
    }
    get getMappingProjectFilterStatus() {
        return this.filterstatus;
    }
    get getMappingProjectStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getMappingProjectListDataUpdate() {
        return this.mappingProjectListDataUpdate;
    }
    get getMappingProjectListDataUpdateMappingProject() {
        return this.mappingProjectListDataUpdateMappingProject;
    }
    get getMappingProjectListDataUpdateHierarchy() {
        return this.mappingProjectListDataUpdateHierarchy;
    }
    get getMappingProjectListDataUpdateIndexHierarchy() {
        return this.mappingProjectListDataUpdateIndexHierarchy;
    }
    get getMappingProjectListDataUpdateWbs() {
        return this.mappingProjectListDataUpdateWbs;
    }
    get getMappingProjectListDataUpdateIndexWbs() {
        return this.mappingProjectListDataUpdateIndexWbs;
    }
    get getMappingProjectWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    [_a = Mutations.SET_MAPPING_PROJECT_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_MAPPING_PROJECT_LIST](payload) {
        return (this.mappingProjectList = payload);
    }
    [_c = Mutations.SET_MAPPING_PROJECT_PAGE](payload) {
        return (this.mappingProjectPaging = payload);
    }
    [_d = Mutations.SET_MAPPING_PROJECT_LOAD_PAGE]() {
        return (this.loadPage = true);
    }
    [_e = Mutations.SET_MAPPING_PROJECT_LOADING](payload) {
        return (this.loading = payload);
    }
    [_f = Mutations.SET_MAPPING_PROJECT_HANDLE_PAGE](payload) {
        return (this.page = payload);
    }
    [_g = Mutations.SET_SELECTED_MAPPING_PROJECT_CODE](payload) {
        return (this.selectedProjectCode = payload);
    }
    [_h = Mutations.SET_SELECTED_MAPPING_PROJECT_DESC](payload) {
        return (this.selectedProjectDescription = payload);
    }
    [_j = Mutations.SET_SELECTED_MAPPING_PROJECT_DIRECTORATE_CODE](payload) {
        return (this.selectedDirectorateCode = payload);
    }
    [_k = Mutations.SET_SELECTED_MAPPING_PROJECT_DIRECTORATE_NAME](payload) {
        return (this.selectedDirectorateName = payload);
    }
    [_l = Mutations.SET_SELECTED_MAPPING_PROJECT_FUNCTION_CODE](payload) {
        return (this.selectedFunctionCode = payload);
    }
    [_m = Mutations.SET_SELECTED_MAPPING_PROJECT_FUNCTION_NAME](payload) {
        return (this.selectedFunctionName = payload);
    }
    [_o = Mutations.SET_SELECTED_MAPPING_PROJECT_DIVISION_CODE](payload) {
        return (this.selectedDivisionCode = payload);
    }
    [_p = Mutations.SET_SELECTED_MAPPING_PROJECT_DIVISION_NAME](payload) {
        return (this.selectedDivisionName = payload);
    }
    [_q = Mutations.SET_SELECTED_MAPPING_PROJECT_DEPARTMENT_CODE](payload) {
        return (this.selectedDepartmentCode = payload);
    }
    [_r = Mutations.SET_SELECTED_MAPPING_PROJECT_DEPARTMENT_NAME](payload) {
        return (this.selectedDepartmentName = payload);
    }
    [_s = Mutations.SET_MAPPING_PROJECT_LIST_CODE](payload) {
        return (this.mappingProjectListProjectCode = payload);
    }
    [_t = Mutations.SET_MAPPING_PROJECT_LIST_DESC](payload) {
        return (this.mappingProjectListProjectDesc = payload);
    }
    [_u = Mutations.SET_MAPPING_PROJECT_LIST_DIRECTORATE_CODE](payload) {
        return (this.mappingProjectListDirectorateCode = payload);
    }
    [_v = Mutations.SET_MAPPING_PROJECT_LIST_DIRECTORATE_NAME](payload) {
        return (this.mappingProjectListDirectorateName = payload);
    }
    [_w = Mutations.SET_MAPPING_PROJECT_LIST_FUNCTION_CODE](payload) {
        return (this.mappingProjectListFunctionCode = payload);
    }
    [_x = Mutations.SET_MAPPING_PROJECT_LIST_FUNCTION_NAME](payload) {
        return (this.mappingProjectListFunctionName = payload);
    }
    [_y = Mutations.SET_MAPPING_PROJECT_LIST_DIVISION_CODE](payload) {
        return (this.mappingProjectListDivisionCode = payload);
    }
    [_z = Mutations.SET_MAPPING_PROJECT_LIST_DIVISION_NAME](payload) {
        return (this.mappingProjectListDivisionName = payload);
    }
    [_0 = Mutations.SET_MAPPING_PROJECT_LIST_DEPARTMENT_CODE](payload) {
        return (this.mappingProjectListDepartmentCode = payload);
    }
    [_1 = Mutations.SET_MAPPING_PROJECT_LIST_DEPARTMENT_NAME](payload) {
        return (this.mappingProjectListDepartmentName = payload);
    }
    [_2 = Mutations.SET_MAPPING_PROJECT_RESET](payload) {
        this.resetMappingProject = payload;
    }
    [_3 = Mutations.SET_MAPPING_PROJECT_STATUS](payload) {
        this.status = payload.status;
        this.statusMessage = payload.statusMessage;
    }
    [_4 = Mutations.SET_MAPPING_PROJECT_USEFILTER](payload) {
        this.useFilter = payload;
    }
    [_5 = Mutations.SET_MAPPING_PROJECT_SIZE](payload) {
        this.size = payload;
    }
    [_6 = Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE](payload) {
        return (this.mappingProjectListDataUpdate = payload);
    }
    [_7 = Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE_MAPPINGPROJECT](payload) {
        return (this.mappingProjectListDataUpdateMappingProject = payload);
    }
    [_8 = Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE_HIERARCHY](payload) {
        return (this.mappingProjectListDataUpdateHierarchy = payload);
    }
    [_9 = Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE_INDEX_HIERARCHY](payload) {
        return (this.mappingProjectListDataUpdateIndexHierarchy = payload);
    }
    [_10 = Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE_WBS](payload) {
        return (this.mappingProjectListDataUpdateWbs = payload);
    }
    [_11 = Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE_INDEX_WBS](payload) {
        return (this.mappingProjectListDataUpdateIndexWbs = payload);
    }
    [_12 = Mutations.SET_MAPPING_PROJECT_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_13 = Mutations.SET_MAPPING_PROJECT_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_14 = Actions.UPDATE_MAPPING_PROJECT_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROJECT_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_15 = Mutations.SET_MAPPING_PROJECT_DESC](payload) {
        this.desc = payload;
    }
    [_16 = Mutations.SET_MAPPING_PROJECT_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_17 = Mutations.SET_MAPPING_PROJECT_FILTER_STATUS](payload) {
        this.filterstatus = payload;
    }
    [_18 = Actions.GET_MAPPING_PROJECT_DATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.useFilter) {
                this.context.dispatch(Actions.GET_MAPPING_PROJECT_LIST);
            }
            else {
                this.context.dispatch(Actions.GET_MAPPING_PROJECT_LIST_FILTER, {
                    projectCode: this.selectedProjectCode,
                    projectDescription: this.selectedProjectDescription
                });
            }
        });
    }
    [_19 = Actions.GET_MAPPING_PROJECT_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LOADING, true);
            const params = {
                ver: 'v1'
            };
            const paramsbody = {
                Page: this.page.toString(),
                Size: this.size.toString()
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingproject/filter?` +
                new URLSearchParams(params).toString();
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsbody)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST, res.data.result.content.data);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_PAGE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_MAPPING_PROJECT_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_20 = Actions.GET_MAPPING_PROJECT_LIST_CODE_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROJECT_WAS_LOAD_QUICK_FILTER, false);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LOADING, true);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingproject/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '10',
                filter: 'NO',
                Desc: this.desc,
                SearchBy: this.searchBy
            };
            const projectCode = [...this.mappingProjectListProjectCode];
            const projectDescription = [...this.mappingProjectListProjectDesc];
            const directorateCode = [...this.mappingProjectListDirectorateCode];
            const directorateName = [...this.mappingProjectListDirectorateName];
            const functionCode = [...this.mappingProjectListFunctionCode];
            const functionName = [...this.mappingProjectListFunctionName];
            const divisionCode = [...this.mappingProjectListDivisionCode];
            const divisionName = [...this.mappingProjectListDivisionName];
            const departmentCode = [...this.mappingProjectListDepartmentCode];
            const departmentName = [...this.mappingProjectListDepartmentName];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_MAPPING_PROJECT_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_MAPPING_PROJECT_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                projectCode.push({
                                    value: data.projectCode,
                                    label: data.projectCode
                                });
                                // distinct data duplicate and remove data null
                                // eslint-disable-next-line arrow-body-style
                                if (projectDescription.filter((x) => {
                                    return x.value === data.projectDescription;
                                }).length == 0) {
                                    projectDescription.push({
                                        value: data.projectDescription,
                                        label: data.projectDescription
                                    });
                                }
                                // eslint-disable-next-line arrow-body-style
                                if (data.directorateCode != null &&
                                    directorateCode.filter((x) => {
                                        return x.value === data.directorateCode;
                                    }).length == 0) {
                                    directorateCode.push({
                                        value: data.directorateCode,
                                        label: data.directorateCode
                                    });
                                }
                                // eslint-disable-next-line arrow-body-style
                                if (data.directorateName != null &&
                                    directorateName.filter((x) => {
                                        return x.value === data.directorateName;
                                    }).length == 0) {
                                    directorateName.push({
                                        value: data.directorateName,
                                        label: data.directorateName
                                    });
                                }
                                // eslint-disable-next-line arrow-body-style
                                if (data.functionCode != null &&
                                    functionCode.filter((x) => {
                                        return x.value === data.functionCode;
                                    }).length == 0) {
                                    functionCode.push({
                                        value: data.functionCode,
                                        label: data.functionCode
                                    });
                                }
                                // eslint-disable-next-line arrow-body-style
                                if (data.functionName != null &&
                                    functionName.filter((x) => {
                                        return x.value === data.functionName;
                                    }).length == 0) {
                                    functionName.push({
                                        value: data.functionName,
                                        label: data.functionName
                                    });
                                }
                                // eslint-disable-next-line arrow-body-style
                                if (data.divisionCode != null &&
                                    divisionCode.filter((x) => {
                                        return x.value === data.divisionCode;
                                    }).length == 0) {
                                    divisionCode.push({
                                        value: data.divisionCode,
                                        label: data.divisionCode
                                    });
                                }
                                // eslint-disable-next-line arrow-body-style
                                if (data.divisionName != null &&
                                    divisionName.filter((x) => {
                                        return x.value === data.divisionName;
                                    }).length == 0) {
                                    divisionName.push({
                                        value: data.divisionName,
                                        label: data.divisionName
                                    });
                                }
                                // eslint-disable-next-line arrow-body-style
                                if (departmentCode != null &&
                                    departmentCode.filter((x) => {
                                        return x.value === data.departmentCode;
                                    }).length == 0) {
                                    departmentCode.push({
                                        value: data.departmentCode,
                                        label: data.departmentCode
                                    });
                                }
                                // eslint-disable-next-line arrow-body-style
                                if (departmentName != null &&
                                    departmentName.filter((x) => {
                                        return x.value === data.departmentName;
                                    }).length == 0) {
                                    departmentName.push({
                                        value: data.departmentName,
                                        label: data.departmentName
                                    });
                                }
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_MAPPING_PROJECT_WAS_LOAD_QUICK_FILTER, false);
                        }
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_CODE, projectCode);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DESC, projectDescription);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIRECTORATE_CODE, directorateCode);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIRECTORATE_NAME, directorateName);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_FUNCTION_CODE, functionCode);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_FUNCTION_NAME, functionName);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIVISION_CODE, divisionCode);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIVISION_NAME, divisionName);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DEPARTMENT_CODE, departmentCode);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DEPARTMENT_NAME, departmentName);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_WAS_LOAD_QUICK_FILTER, true);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_MAPPING_PROJECT_WAS_LOAD_QUICK_FILTER, true);
                    reject(false);
                });
            });
        });
    }
    [_21 = Actions.CREATE_MAPPING_PROJECT_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LOADING, true);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingproject?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_STATUS, {
                            status: res.data.statusCode,
                            statusMessage: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_HANDLE_PAGE, this.page);
                        this.context.dispatch(Actions.GET_MAPPING_PROJECT_DATA);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_22 = Actions.UPDATE_MAPPING_PROJECT_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingproject?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.put(url, data)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_STATUS, {
                            status: res.data.statusCode,
                            statusMessage: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_HANDLE_PAGE, this.page);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_23 = Actions.GET_MAPPING_PROJECT_LIST_FILTER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_CODE, data.projectCode);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_DESC, data.projectDescription);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_DIRECTORATE_CODE, data.directorateCode);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_DIRECTORATE_NAME, data.directorateName);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_FUNCTION_CODE, data.functionCode);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_FUNCTION_NAME, data.functionName);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_DIVISION_CODE, data.divisionCode);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_DIVISION_NAME, data.divisionName);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_DEPARTMENT_CODE, data.departmentCode);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_DEPARTMENT_NAME, data.departmentName);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingproject/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: this.desc,
                SearchBy: this.searchBy,
                filter: 'No',
                ProjectCode: data.projectCode,
                ProjectDescription: data.projectDescription,
                DirectorateCode: data.directorateCode,
                DirectorateName: data.directorateName,
                FunctionCode: data.functionCode,
                FunctionName: data.functionName,
                DivisionCode: data.divisionCode,
                DivisionName: data.divisionName,
                DepartmentCode: data.departmentCode,
                DepartmentName: data.departmentName
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _32, _33;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST, ((_32 = res.data.result.content) === null || _32 === void 0 ? void 0 : _32.data) || []);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_PAGE, ((_33 = res.data.result.content) === null || _33 === void 0 ? void 0 : _33.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_RESET, false);
                        if (!this.loadPage) {
                            this.context.commit(Mutations.SET_MAPPING_PROJECT_LOAD_PAGE, true);
                        }
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_24 = Actions.DOWNLOAD_MAPPING_PROJECT]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/mappingproject/download?ver=v1`;
            axios({
                url: apiUrl,
                method: 'POST',
                responseType: 'blob',
                data: {
                    projectCode: this.selectedProjectCode,
                    projectDescription: this.selectedProjectDescription,
                    DirectorateCode: this.selectedDirectorateCode,
                    DirectorateName: this.selectedDirectorateName,
                    FunctionCode: this.selectedFunctionCode,
                    FunctionName: this.selectedFunctionName,
                    DivisionCode: this.selectedDivisionCode,
                    DivisionName: this.selectedDivisionName,
                    DepartmentCode: this.selectedDepartmentCode,
                    DepartmentName: this.selectedDepartmentName
                }
            }).then((response) => {
                // eslint-disable-next-line comma-spacing
                const fileName = response.headers['content-disposition']
                    .split('; ')[1]
                    .split('=')[1]
                    .replaceAll('/', '-')
                    .replaceAll('"', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_25 = Actions.GET_MAPPING_PROJECT_DATA_UPDATE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1',
                Page: '1',
                Size: '10',
                Desc: this.desc
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingproject/detail?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                projectID: [data.projectID]
            };
            const dataMappingProject = [];
            const dataHierarchy = [];
            const dataWbs = [];
            const populateIndexRowHierarchy = [];
            const populateIndexRowWbs = [];
            let indexHierarchy = -1;
            let indexWbs = -1;
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _32;
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            res.data.result.content.data.map((data) => {
                                // eslint-disable-next-line arrow-body-style
                                if (dataMappingProject.filter((x) => {
                                    return x.projectCode === data.projectCode;
                                }).length == 0) {
                                    dataMappingProject.push({
                                        projectID: data.projectID,
                                        projectCode: data.projectCode,
                                        projectDescription: data.projectDescription,
                                        directorateCode: data.directorateCode,
                                        directorateName: data.directorateName,
                                        functionCode: data.functionCode,
                                        functionName: data.functionName,
                                        divisionCode: data.divisionCode,
                                        divisionName: data.divisionName,
                                        departmentCode: data.departmentCode,
                                        departmentName: data.departmentName
                                    });
                                }
                                // eslint-disable-next-line arrow-body-style
                                if (dataHierarchy.filter((x) => {
                                    return x.detailID === data.detailID;
                                }).length == 0) {
                                    dataHierarchy.push({
                                        detailID: data.detailID,
                                        hierarchyProfiling: data.hierarchyProfiling,
                                        hierarchyProfillingDesc: data.hierarchyProfillingDesc,
                                        isDeleted: data.isDeleted,
                                        index: indexHierarchy + 1
                                    });
                                    populateIndexRowHierarchy.push(indexHierarchy + 1);
                                    indexHierarchy = indexHierarchy + 1;
                                }
                                // eslint-disable-next-line arrow-body-style
                                if (dataWbs.filter((x) => {
                                    return x.detailIDWBS === data.detailIDWBS;
                                }).length == 0) {
                                    dataWbs.push({
                                        detailIDWBS: data.detailIDWBS,
                                        wbs: data.wbs,
                                        wbsDescription: data.wbsDescription,
                                        isDeleted: data.isDeleted,
                                        index: indexWbs + 1
                                    });
                                    populateIndexRowWbs.push(indexWbs + 1);
                                    indexWbs = indexWbs + 1;
                                }
                            });
                        }
                        else {
                            dataMappingProject.push({
                                projectID: null,
                                projectCode: null,
                                projectDescription: null,
                                directorateCode: null,
                                directorateName: null,
                                functionCode: null,
                                functionName: null,
                                divisionCode: null,
                                divisionName: null,
                                departmentCode: null,
                                departmentName: null
                            });
                            dataHierarchy.push({
                                detailID: null,
                                hierarchyProfiling: null,
                                hierarchyProfillingDesc: null,
                                isDeleted: null,
                                index: indexHierarchy
                            });
                            dataWbs.push({
                                detailIDWBS: null,
                                wbs: null,
                                wbsDescription: null,
                                isDeleted: null,
                                index: indexWbs
                            });
                            populateIndexRowHierarchy.push(indexHierarchy);
                            populateIndexRowWbs.push(indexWbs);
                        }
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_STATUS, {
                            status: res.data.statusCode,
                            statusMessage: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE, ((_32 = res.data.result.content) === null || _32 === void 0 ? void 0 : _32.data) || res.data.result.content);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE_MAPPINGPROJECT, dataMappingProject);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE_HIERARCHY, dataHierarchy);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE_INDEX_HIERARCHY, populateIndexRowHierarchy);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE_WBS, dataWbs);
                        this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DATAUPDATE_INDEX_WBS, populateIndexRowWbs);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_26 = Actions.UPDATE_MAPPING_PROJECT_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROJECT_SIZE, data);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_MAPPING_PROJECT_DATA);
        });
    }
    [_27 = Actions.RESET_MAPPING_PROJECT_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROJECT_RESET, true);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_DESC, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_CODE, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_USEFILTER, false);
            this.context.dispatch(Actions.GET_MAPPING_PROJECT_DATA);
        });
    }
    [_28 = Actions.UPDATE_SELECTED_MAPPING_PROJECT_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROJECT_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_DESC, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_CODE, data);
            this.context.dispatch(Actions.GET_MAPPING_PROJECT_DATA);
        });
    }
    [_29 = Actions.UPDATE_SELECTED_MAPPING_PROJECT_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROJECT_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_DESC, data);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROJECT_CODE, []);
            this.context.dispatch(Actions.GET_MAPPING_PROJECT_DATA);
        });
    }
    [_30 = Actions.UPDATE_MAPPING_PROJECT_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROJECT_SEARCH_BY, data === '' ? '' : 'projectcode');
            this.context.commit(Mutations.SET_MAPPING_PROJECT_PAGE_FILTER, 1);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_CODE, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DESC, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIRECTORATE_CODE, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIRECTORATE_NAME, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_FUNCTION_CODE, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_FUNCTION_NAME, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIVISION_CODE, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIVISION_NAME, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DEPARTMENT_CODE, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DEPARTMENT_NAME, []);
            this.context.dispatch(Actions.GET_MAPPING_PROJECT_LIST_CODE_DESC);
        });
    }
    [_31 = Actions.UPDATE_MAPPING_PROJECT_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROJECT_SEARCH_BY, data === '' ? '' : 'projectdescription');
            this.context.commit(Mutations.SET_MAPPING_PROJECT_PAGE_FILTER, 1);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_CODE, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DESC, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIRECTORATE_CODE, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIRECTORATE_NAME, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_FUNCTION_CODE, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_FUNCTION_NAME, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIVISION_CODE, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DIVISION_NAME, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DEPARTMENT_CODE, []);
            this.context.commit(Mutations.SET_MAPPING_PROJECT_LIST_DEPARTMENT_NAME, []);
            this.context.dispatch(Actions.GET_MAPPING_PROJECT_LIST_CODE_DESC);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _r, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _s, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _t, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _u, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _v, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _w, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _x, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _y, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _z, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _0, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _1, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _2, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _3, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _4, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _5, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _6, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _7, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _8, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _9, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _10, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _11, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _12, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _13, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _14, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _15, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _16, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MappingProject.prototype, _17, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _18, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _19, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _20, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _21, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _22, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _23, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _24, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _25, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _26, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _27, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _28, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _29, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _30, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MappingProject.prototype, _31, null);
MappingProject = __decorate([
    Module
], MappingProject);
export default MappingProject;
